import { LanguageCode } from "./languages";
import { PlanProps } from "./plan";
import { QrStatus } from "./qr";
import { SubscriptionStatus } from "./subscription";

export enum UserStatus {
  ANONYMOUS = "Anonymous",
  REGISTERED = "Registered",
  SUBSCRIBED = "Subscribed",
  UNSUBSCRIBED = "Unsubscribed",
  TRIAL = "Trial",
}

export enum UserRole {
  ADMIN = "Admin",
  EDITOR = "Editor",
  VIEWER = "Viewer",
}

export type EmailProvider = "google" | "email";

export interface UserProps {
  accountId?: string;
  userId: string;
  firstName: string;
  lastName: string;
  phone: string;
  userStatus: UserStatus;
  qrStatus: QrStatus;
  provider?: EmailProvider;
  selectedSubscriptionId?: string;
  email: string;
  freeTrialStartsAt: string | null;
  freeTrialEndsAt: string | null;
  countryIsoCode?: string;
  currency?: string;
  subscription: {
    id: string;
    status: SubscriptionStatus;
    subscribed: boolean;
    unsubscribedAt?: string;
    requestedUnsubscribedAt?: string;
    payAt?: string;
    plan: PlanProps;
  };
  locale: LanguageCode;
  role?: UserRole;
  status: UserStatus;
}
